<mat-card class="dialog-card link-receivers">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar flex flex-row items-center justify-between" color="accent">
      <div class="flex flex-row items-center gap-5">
        <h1 class="dialog-card-title">{{ 'SITES.LINK_RECEIVERS_FORM.TITLE' | translate }}</h1>
        @if (loader$ | async) {
          <mat-progress-spinner [diameter]="20" mode="indeterminate" />
        }
      </div>
      <button (click)="exit()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content flex flex-col gap-5">
    <section class="link-receivers__form flex-1 p-4">
      <form [formGroup]="usersForm" class="flex flex-1 flex-row gap-2.5">
        <div class="w-[16%]">
          <mat-radio-group
            [value]="isMainStock"
            aria-labelledby="is-main-stock-radio-group-label"
            color="accent"
            formControlName="isMainStock"
            class="flex flex-col gap-2.5"
          >
            <mat-radio-button [value]="false">{{ 'SITES.WARDS.TABLE.WARD_TYPE.DEFAULT' | translate }}</mat-radio-button>
            <mat-radio-button [value]="true">{{ 'SITES.WARDS.TABLE.WARD_TYPE.PRIMARY' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
        <mat-form-field color="accent" class="flex-[0_0_16%]">
          <mat-label>{{ 'SITES.WARDS.TABLE.UF' | translate }}</mat-label>
          <input formControlName="uf" matInput maxlength="50" />
        </mat-form-field>
        <mat-form-field color="accent" class="flex-[0_0_16%]">
          <mat-label>{{ 'SITES.WARDS.TABLE.NAME' | translate }}</mat-label>
          <input formControlName="name" matInput maxlength="50" required />
        </mat-form-field>
        <mat-form-field color="accent" class="flex-[0_0_16%]">
          <mat-label>{{ 'SITES.WARDS.TABLE.BUILDING' | translate }}</mat-label>
          <input formControlName="building" matInput maxlength="50" />
        </mat-form-field>
        <mat-form-field color="accent" class="flex-[0_0_16%]">
          <mat-label>{{ 'SITES.WARDS.TABLE.FLOOR' | translate }}</mat-label>
          <input formControlName="floor" matInput maxlength="50" />
        </mat-form-field>
        <mat-form-field color="accent" class="flex-[0_0_16%]">
          <mat-label>{{ 'SITES.WARDS.TABLE.LOCATION' | translate }}</mat-label>
          <input formControlName="comment" matInput maxlength="50" />
        </mat-form-field>
      </form>
    </section>
    <div class="link-receivers__list flex flex-1 flex-row gap-5">
      <section class="flex flex-col" style="width: calc(50% - 4px)">
        <mat-toolbar class="mat-toolbar--gray flex flex-row items-center gap-2.5">
          <p>{{ (unselectedReceivers$ | async)?.length }} {{ 'SITES.LINK_RECEIVERS_FORM.UNPAIR_RECEIVERS' | translate | uppercase }}</p>
        </mat-toolbar>
        <mat-list class="height-300 two-line-list flex flex-1 flex-col p-4">
          @for (receiver of unselectedReceivers$ | async; track receiver.id) {
            <mat-list-item [lines]="2" [matTooltip]="$safeNavigationMigration(receiver?.name)" class="hoverable min-h-12!" matTooltipClass="regular-tooltip">
              <mat-icon matListItemIcon>work_outline</mat-icon>
              <h3 matListItemTitle>{{ receiver?.devEui }}</h3>
              <button
                (click)="addReceiver(receiver)"
                [disabled]="loader$ | async"
                class="regular-round-button flex! items-center!"
                mat-icon-button
                matListItemMeta
              >
                <mat-icon>add</mat-icon>
              </button>
              <p class="complementary-line" matListItemLine>
                <span>{{ receiver?.name }}</span>
              </p>
            </mat-list-item>
          }
        </mat-list>
      </section>
      <section class="flex flex-col" style="width: calc(50% - 4px)">
        <mat-toolbar class="mat-toolbar--gray flex flex-row items-center gap-2.5">
          <p>{{ (selectedReceivers$ | async)?.length }} {{ 'SITES.LINK_RECEIVERS_FORM.SELECTED_RECEIVERS' | translate | uppercase }}</p>
        </mat-toolbar>
        <mat-list class="height-300 two-line-list flex flex-1 flex-col p-4">
          @for (receiver of selectedReceivers$ | async; track receiver.id) {
            <mat-list-item [lines]="2" [matTooltip]="$safeNavigationMigration(receiver?.name)" class="hoverable min-h-12!" matTooltipClass="regular-tooltip">
              <mat-icon matListItemIcon>work</mat-icon>
              <h3 matListItemTitle>{{ receiver?.devEui }}</h3>
              <button
                (click)="removeReceiver(receiver)"
                [disabled]="loader$ | async"
                class="regular-round-button flex! items-center!"
                mat-icon-button
                matListItemMeta
              >
                <mat-icon>delete</mat-icon>
              </button>
              <p class="complementary-line" matListItemLine>
                <span>{{ receiver?.name }}</span>
              </p>
            </mat-list-item>
          }
        </mat-list>
      </section>
    </div>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions flex flex-row items-center justify-end">
    <button (click)="exit()" class="button-regular" color="accent" mat-raised-button>{{ 'SITES.LINK_RECEIVERS_FORM.DONE' | translate }}</button>
  </mat-card-actions>
</mat-card>
